<template>
  <a-card class="auto-height">
    <a-tabs :defaultActiveKey="1" type="card">
      <a-tab-pane key="1" tab="管理平台">
        <a-row :gutter="20">
          <a-col
            :xxl="5"
            :xl="8"
            :lg="9"
            :md="24"
            :sm="24"
            class="first-col">
            <a-row :gutter="8">
              <a-col :lg="20" :md="24">
                <a-input-search style="margin-bottom: 1rem" placeholder="软件公司名称搜索" @change="onChange"/>
              </a-col>
              <a-col :lg="4" :md="24">
                <a-button type="primary" icon="plus" @click="handleAddOrEditVendor()"/>
              </a-col>
            </a-row>
            <a-list
              itemLayout="horizontal"
              :loading="loading"
              :dataSource="filteredCompanyList"
              style="max-height: 80vh; overflow-y: auto;">
              <a-list-item slot="renderItem" slot-scope="item" class="vendor-item" @click="(e) => handleClick(e, item)">
                <a-icon slot="actions" type="edit" class="action" @click="handleAddOrEditVendor(item)"/>
                <a-icon v-if="!item.hotels || item.hotels.length === 0" slot="actions" type="delete" class="action" @click="handleRemoveVendor(item)"/>
                <a-list-item-meta>
                  <LauncherSvg slot="avatar" class="avatar"/>
                  <div slot="title">{{ item.name }}</div>
                  <div slot="description" class="desc">
                    <div>地址：<ellipsis :length="40" tooltip>{{ getAreaName(item.province) + (item.address || '') || '无' }}</ellipsis></div>
                    <div>联系方式：<ellipsis :length="12" tooltip>{{ item.mobile || '无' }}</ellipsis></div>
                  </div>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-col>

          <a-col
            v-if="!this.lastItem"
            :xxl="19"
            :xl="16"
            :lg="15"
            :md="24"
            :sm="24">
            <div class="center blank">
              <div class="blank-tip">请先在左侧选择公司</div>
            </div>
          </a-col>

          <a-col
            v-else
            :xxl="19"
            :xl="16"
            :lg="15"
            :md="24"
            :sm="24">
            <div class="account-management">
              <div class="account-header">
                <h3>账号列表</h3>
                <a-button type="primary" @click="handleAddOrEditAccount()">+ 账号</a-button>
              </div>
              <a-table
                :loading="tableLoading"
                :columns="accountColumns"
                :dataSource="accountList.content || []"
                :pagination="{
                  current: pagination.current,
                  pageSize: pagination.pageSize,
                  total: accountList.totalElements || 0,
                  showSizeChanger: true,
                  pageSizeOptions: ['10', '20', '50', '100'],
                  onChange: handleTableChange,
                  onShowSizeChange: handleTableChange
                }">
                <span slot="action" slot-scope="record">
                  <a @click="handleResetPassword(record)">重置密码</a>
                  <a-divider type="vertical"/>
                  <a @click="handleAddOrEditAccount(record)">编辑</a>
                  <a-divider type="vertical"/>
                  <a style="color: red" @click="handleRemoveAccount(record)">删除</a>
                </span>
              </a-table>
            </div>
          </a-col>
        </a-row>
      </a-tab-pane>
      <a-tab-pane key="2" tab="数据统计">
        <DataStatistics :type="1" />
      </a-tab-pane>
    </a-tabs>

    <CompanyModal :visible.sync="visible.companyModal" :id="vendorId" ref="avm" @ok="handleOK2"/>
    <AccountModal
      :visible.sync="visible.accountModal"
      :account="currentAccount"
      :accountList="accountList.content || []"
      :corpId="vendorId"
      ref="accountModal"
      @ok="handleAccountOK"
      @cancel="handleAccountCancel"/>

    <!-- 重置密码弹窗 -->
    <a-modal
      title="重置密码"
      :visible="visible.resetPasswordModal"
      @ok="handleResetPasswordSubmit"
      @cancel="handleResetPasswordCancel">
      <a-form :form="form">
        <a-form-item label="账号密码" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
          <a-input
            type="password"
            v-decorator="['password', {
              rules: [
                { required: true, message: '请输入账号密码' },
                { validator: validatePassword }
              ]
            }]"
            placeholder="请输入（8位以上数字+字母）"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { listCompanyPage, deleteCompany, listCompanyUserPage, deleteCompanyUser, resetCompanyUserPassword } from '@/api/company'
import { mixinDevice } from '@/utils/mixin'
import CompanyModal from './modal/companyModal.vue'
import AccountModal from './modal/accountModal.vue'
import DataStatistics from './components/DataStatistics.vue'
import { Ellipsis } from '@/components'
import LauncherSvg from '@/assets/launcher.svg?inline'
import { getAreaName } from '@/utils/area'

export default {
  components: {
    Ellipsis,
    CompanyModal,
    AccountModal,
    DataStatistics,
    LauncherSvg
  },
  mixins: [mixinDevice],
  data: function () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      tableLoading: false,
      visible: {
        companyModal: false,
        accountModal: false,
        input: false,
        resetPasswordModal: false
      },
      disabled: false,
      spinning: false,
      keyword: '',
      lastItem: null,
      vendorId: '',
      companyList: [],
      accountList: [],
      currentAccount: null,
      apkList: [],
      closing: false,
      // 重置密码相关
      resetPasswordAccount: null,
      newPassword: '',
      // 分页相关
      pagination: {
        current: 0,
        pageSize: 10
      },
      accountColumns: [{
        title: '账号名称',
        dataIndex: 'username',
        key: 'username'
      }, {
        title: '手机',
        dataIndex: 'mobile',
        key: 'mobile'
      }, {
        title: '授权数量',
        dataIndex: 'max',
        key: 'max'
      }, {
        title: '已激活数量',
        dataIndex: 'activeCnt',
        key: 'activeCnt',
        formatter: (text) => {
          return text || 0
        }
      }, {
        title: '操作',
        width: 200,
        fixed: 'right',
        scopedSlots: { customRender: 'action' }
      }]
    }
  },
  computed: {
    filteredCompanyList () {
      if (this.keyword) {
        return this.companyList.filter(v => v.name.indexOf(this.keyword) > -1)
      } else {
        return this.companyList
      }
    }
  },
  mounted () {
    this.loadCompany()
  },
  methods: {
    getAreaName,
    handleClick (e, company) {
      this.vendorId = company.id
      if (this.lastItem && this.lastItem !== e.currentTarget) {
        this.lastItem.classList.remove('vendor-item-active')
      }
      e.currentTarget.classList.add('vendor-item-active')
      this.lastItem = e.currentTarget
      // 重置分页到第一页
      this.pagination.current = 0
      // 根据不同公司加载不同的账号数据
      this.loadAccountData(company.id, this.pagination.current, this.pagination.pageSize)
    },
    validatePassword (rule, value, callback) {
      if (!value) {
        callback(new Error('请输入账号密码'))
        return
      }
      if (value.length < 8) {
        callback(new Error('密码长度必须大于8位'))
        return
      }
      if (!/[A-Za-z]/.test(value) || !/\d/.test(value)) {
        callback(new Error('密码必须同时包含数字和字母'))
        return
      }
      callback()
    },
    loadAccountData (companyId, page = 0, pageSize = 10) {
      console.log('loadAccountData', companyId, page, pageSize)
      this.tableLoading = true
      listCompanyUserPage({
        corpId: companyId,
        pageNumber: page,
        pageSize: pageSize
      }).then(res => {
        this.accountList = res.data || []
        this.tableLoading = false
      }).catch(err => {
        console.error('加载账号数据失败:', err)
        this.tableLoading = false
      })
    },

    loadCompany (keepSelect) {
      if (!keepSelect) {
        this.vendorId = ''
        this.lastItem = null
      }
      this.loading = true
      listCompanyPage().then(response => {
        this.companyList = response.data || []
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },

    onChange (e) {
      const value = e.target.value
      if (value) {
        this.keyword = value.trim()
        if (this.keyword && this.lastItem) {
          this.lastItem.classList.remove('vendor-item-active')
        }
      } else {
        this.keyword = ''
      }
    },

    handleTableChange (current, pageSize, filters, sorter) {
      console.log('handleTableChange', current, pageSize, filters, sorter)
      this.pagination = {
        current: current,
        pageSize: pageSize
      }
      this.loadAccountData(this.vendorId, current - 1, pageSize)
    },

    handleAddOrEditVendor (vendor) {
      this.visible.companyModal = true
      console.log('handleAddOrEditVendor', vendor, this.$refs)
      if (vendor) {
        this.$nextTick(() => this.$refs.avm.load(vendor))
      }
    },
    handleRemoveVendor (record) {
      const _this = this
      let seconds = 5
      const modal = this.$confirm({
        title: '提示',
        content: (
          <div>
              确定要删除公司<span style="font-weight: 600"> { record.name } </span>吗？
          </div>
        ),
        okType: 'danger',
        okText: `等待 ${seconds} 秒`,
        okButtonProps: { props: { disabled: true } },
        onOk () {
          modal.update({ okButtonProps: { props: { loading: true } } })
          deleteCompany(record.id).then(response => {
            _this.$message.success(response.msg)
            _this.loadCompany()
            modal.destroy()
          }).catch(err => {
            console.log(err)
          })
        }
      })
      const interval = setInterval(() => {
        seconds -= 1
        modal.update({
          okText: `等待 ${seconds} 秒`
        })
      }, 1000)
      setTimeout(() => {
        clearInterval(interval)
        modal.update({
          okText: '删除',
          okButtonProps: { props: { disabled: false } }
        })
      }, seconds * 1000)
    },

    handleAddHotel () {
      this.visible.companyModal = true
    },

    handleEditHotel (hotel) {
      this.visible.companyModal = true
      this.$nextTick(() => this.$refs.hm.load(hotel))
    },
    handleOK2 (hotel) {
      let isCreate = true
      for (let i = 0; i < this.companyList.length; i++) {
        if (this.companyList[i].id === hotel.id) {
          const e = this.companyList[i]
          e.name = hotel.name
          e.mobile = hotel.mobile
          e.address = hotel.address
          e.province = hotel.province
          isCreate = false
          break
        }
      }
      if (isCreate) {
        this.companyList.push(hotel)
      }
      this.companyList.sort((a, b) => a.sort - b.sort)
      this.loadCompany(true)
    },

    showInput () {
      this.visible.input = true
      this.$nextTick(() => this.$refs.input.focus())
    },

    handleInputCancel () {
      this.visible.input = false
    },

    handleAddOrEditAccount (account) {
      this.currentAccount = account
      this.visible.accountModal = true
    },

    handleRemoveAccount (account) {
      const _this = this
      this.$confirm({
        title: '提示',
        content: '确定要删除账号“ ' + account.username + '”吗？',
        okType: 'danger',
        onOk () {
          // 模拟删除操作
          setTimeout(() => {
            deleteCompanyUser(account.id).then(res => {
              console.log(res)
              if (res.code === 1) {
                _this.$message.success('账号删除成功')
                _this.loadAccountData(_this.vendorId)
              }
            })
          }, 500)
        }
      })
    },

    handleAccountOK () {
      this.loadAccountData(this.vendorId)
      this.visible.accountModal = false
    },

    handleAccountCancel () {
      this.visible.accountModal = false
      this.currentAccount = null
    },

    // 打开重置密码弹窗
    handleResetPassword (record) {
      this.resetPasswordAccount = record
      this.newPassword = '' // 重置密码输入框
      this.visible.resetPasswordModal = true
    },

    // 提交重置密码
    handleResetPasswordSubmit () {
      console.log(this.form)
      this.form.validateFields().then((values) => {
        console.log(values)
        resetCompanyUserPassword(
          this.resetPasswordAccount.id,
          values.password
        ).then(res => {
          if (res.code === 1) {
            this.$message.success('密码重置成功')
            this.handleResetPasswordCancel()
          } else {
            this.$message.error(res.msg || '密码重置失败')
          }
        }).catch(err => {
          console.error('重置密码失败:', err)
          this.$message.error('密码重置失败')
        })
      })
    },

    // 取消重置密码
    handleResetPasswordCancel () {
      this.visible.resetPasswordModal = false
      this.resetPasswordAccount = null
      this.newPassword = ''
      this.form.resetFields()
    }
  }
}
</script>

  <style lang="less" scoped>
    .first-col {
      margin-bottom: 2vh;

      &:after {
        position: absolute;
        top: 0.1em;
        right: 0;
        width: 0;
        height: calc(100% - 0.2em);
        content: '';
        border-right: 1px solid #e8e8e8;
      }
    }

    .vendor-item {
      &:hover {
        cursor: pointer;
        border: 1px solid #7dc6ff;
        background-color: #d2ecff;
      }

      /deep/ .ant-list-item-meta-avatar {
        margin: auto 15px auto 10px;
      }

      .avatar {
        width: 40px;
        height: 40px;
      }

      .action:hover {
        color: #1890ff;
      }

      .desc {
        font-size: 13px;
      }
    }

    .vendor-item-active {
      border: 1px solid #7dc6ff;
      background-color: #d2ecff;
    }

    .blank {
      margin-top: 100px;

      &-intro {
        margin: 2vh auto;
      }

      &-tip {
        margin: 2vh auto;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.45);
      }
    }

    .table-tag {
      &:not(:first-child) {
        margin-top: 4px;
      }
    }

    .table-render {
      color: rgba(0, 0, 0, .45)
    }

    .hotel-button-wrapper {
      margin-bottom: 16px;
      min-height: 32px;

      .hotel-button {
        float: right;
      }
    }

    .code-action {
      font-family: "Consolas", monospace;
      font-size: 15px;
      font-weight: 500;

      a {
        color: gray;
        margin-left: 6px;

        &:hover {
          color: #1890ff;
        }
      }
    }

    .apk-panel {
      padding: 12px 24px;

      .apk-input {
        width: 150px;
      }

      .apk-input-tag {
        background: #fff;
        border: 1px dashed rgba(0, 0, 0, 0.45);
        width: 150px;
        height: 32px;
        text-align: center;
      }

      /deep/ .ant-tag {
        font-size: 16px;
        line-height: 30px;
        height: 32px;
        margin-bottom: 16px;
      }
    }

    .account-management {
      .account-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;

        h3 {
          margin: 0;
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
  </style>
